import { NavLink, Outlet } from "react-router-dom";

import { AdminAvatar } from "@/components/admin/avatar";
import { AdminIcon } from "@/components/admin/icon";
import { PageHead } from "@/components/admin/page-head";
import { useAuth } from "@/hooks/use-auth";
import { cn } from "@/lib/cn";

const TABS = [
	{ to: "/profil", label: "Identité", end: true },
	{ to: "/profil/securite", label: "Sécurité" },
	{ to: "/profil/sessions", label: "Sessions" },
	{ to: "/profil/preferences", label: "Préférences" },
];

export function ProfileLayout() {
	const { user } = useAuth();
	if (!user) return null;

	return (
		<>
			<div className="crumbs" style={{ marginBottom: 14, fontSize: 12 }}>
				<span className="root">Compte</span>
				<span className="sep">
					<AdminIcon n="chevR" s={10} />
				</span>
				<span className="here">Mon profil</span>
			</div>

			<PageHead
				title={`Mon profil`}
				sub={`${user.fullName} · ${user.role.label} · ${user.email}`}
				actions={
					<div style={{ display: "flex", alignItems: "center", gap: 12 }}>
						<AdminAvatar name={user.fullName} size="lg" />
					</div>
				}
			/>

			<div
				style={{
					display: "flex",
					gap: 4,
					borderBottom: "1px solid var(--a-border)",
					marginBottom: 20,
				}}
				data-testid="profile-tabs"
			>
				{TABS.map((t) => (
					<NavLink
						key={t.to}
						to={t.to}
						end={t.end}
						className={({ isActive }) =>
							cn("profile-tab", isActive && "profile-tab-active")
						}
						style={({ isActive }) => ({
							padding: "10px 16px",
							fontSize: 13,
							fontWeight: isActive ? 600 : 500,
							color: isActive ? "var(--a-terracotta)" : "var(--a-ink-soft)",
							borderBottom: isActive
								? "2px solid var(--a-terracotta)"
								: "2px solid transparent",
							marginBottom: -1,
							cursor: "pointer",
							textDecoration: "none",
						})}
						data-testid={`profile-tab-${t.to === "/profil" ? "identity" : (t.to.split("/").pop() ?? "identity")}`}
					>
						{t.label}
					</NavLink>
				))}
			</div>

			<Outlet />
		</>
	);
}
